var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.314 45.9903C120.601 55.2254 122.052 65.5243 120.486 75.5846C118.919 85.6448 114.404 95.0144 107.511 102.508C100.619 110.002 91.6595 115.284 81.7653 117.686C71.8711 120.087 61.4869 119.501 51.926 116.001C42.3652 112.5 34.0571 106.243 28.0526 98.0206C22.048 89.7982 18.6167 79.9798 18.1926 69.8071C17.7685 59.6344 20.3707 49.5645 25.67 40.8708C30.9694 32.1771 38.7278 25.2502 47.9641 20.9662C60.3468 15.2247 74.5027 14.6355 87.3197 19.3281C100.137 24.0206 110.566 33.6108 116.314 45.9903Z",
    fill: "#705DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4039 79.3739C101.433 75.2879 104.161 70.0993 105.243 64.4635C106.325 58.8278 105.712 52.9978 103.482 47.7103C101.252 42.4228 97.5042 37.9149 92.7131 34.7562C87.922 31.5976 82.3021 29.9299 76.5636 29.9639C70.825 29.9979 65.2253 31.7321 60.472 34.9473C55.7186 38.1625 52.0249 42.7144 49.8575 48.028C47.6901 53.3416 47.1463 59.1784 48.2948 64.8009C49.4433 70.4235 52.2326 75.5794 56.3102 79.6174C61.7949 85.0286 69.2028 88.0422 76.9074 87.9965C84.612 87.9509 91.9837 84.8497 97.4039 79.3739Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9064 89.2754C25.9051 95.7617 30.2247 101.551 35.5889 106.272C40.953 110.993 47.2435 114.543 54.0581 116.694C54.6381 112.192 54.1721 107.617 52.6963 103.325C51.2204 99.0327 48.7745 95.1387 45.5487 91.9456C42.3229 88.7525 38.4041 86.3464 34.097 84.9144C29.79 83.4824 25.2106 83.063 20.7151 83.6889C21.3384 85.5913 22.07 87.4565 22.9064 89.2754Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3228 42.3787C39.561 37.5044 42.6891 30.7775 43.0407 23.6309C37.6001 26.8866 32.8116 31.1247 28.919 36.1295L28.662 36.4609C28.3982 36.799 28.148 37.1372 27.8977 37.4957C27.6475 37.8541 27.3499 38.2599 27.0794 38.6454L26.7547 39.1324C24.6991 42.2263 22.9869 45.535 21.6484 49C26.3888 47.9646 30.7653 45.6783 34.3228 42.3787Z",
    fill: "#F4F4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.355 89.1739C109.282 89.1449 102.474 91.8573 97.3588 96.7415C92.2438 101.626 89.2202 108.302 88.9229 115.368C89.7074 115.05 90.4919 114.692 91.2697 114.354C102.367 109.221 111.264 100.291 116.355 89.1739Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.943 59.5778L78.1015 56.2908C77.4612 55.7498 76.5595 54.9359 75.3962 53.8493C74.2126 52.7604 73.5498 52.1111 73.3672 51.9218L73.259 52.03C73.7609 53.1365 74.1682 54.2836 74.4764 55.459L77.1005 64.799L81.943 59.5643V59.5778ZM92.2503 55.628L89.8223 58.2454L94.5566 62.2493L90.4039 66.7469L85.6696 62.743L77.0938 72.0425L73.7121 69.1952L67.8687 47.1739L71.7914 42.9333L86.0957 55.1073L88.517 52.4899L92.2503 55.6619V55.628Z",
    fill: "#5046D1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M99.3179 108.104C77.4319 124.336 50.1691 124.593 38.4483 108.74C26.7275 92.887 34.9044 66.8821 56.7903 50.6773C78.6763 34.4725 105.939 34.1884 117.66 50.0483C129.381 65.9082 121.204 91.8995 99.3179 108.104Z",
    fill: "url(#paint0_radial_85_559)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.459,
    width: 83.1884,
    height: 85.2174,
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.6716,
    y: 79.8068,
    width: 77.1014,
    height: 60.1932,
    fill: "url(#pattern1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.08694,
    width: 66.9565,
    height: 73.7198,
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.8618 36.3459C32.4898 39.4097 39.9024 38.4561 49.4183 34.229C58.9343 30.002 66.942 24.0841 67.314 21.0203C67.686 17.9565 60.2734 18.9372 50.7575 23.1372C41.2415 27.3372 33.2338 33.2821 32.8618 36.3459Z",
    fill: "url(#paint1_radial_85_559)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M67.0609 56.2837C73.3884 41.1721 67.8456 24.453 54.6806 18.9406C41.5157 13.4282 25.7139 21.2099 19.3864 36.3215C13.0589 51.4331 18.6017 68.1521 31.7667 73.6645C44.9316 79.177 60.7333 71.3953 67.0609 56.2837Z",
    fill: "url(#paint2_radial_85_559)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M66.4212 30.685C62.4985 31.3614 59.7391 34.6821 60.2599 38.1247C60.7807 41.5672 64.3787 43.799 68.3014 43.1362C72.2241 42.4734 74.9836 39.1391 74.4695 35.6966C73.9555 32.2541 70.3439 30.0155 66.4212 30.685Z",
    fill: "url(#paint3_radial_85_559)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_85_559",
    transform: "scale(0.00813008 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_85_559",
    transform: "scale(0.00877193 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_85_559",
    transform: "scale(0.010101 0.00917431)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_85_559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.4639 81.1272) rotate(53.4475) scale(35.6032 49.3104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9B9BA3",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B9BA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_85_559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5544 26.892) rotate(156.067) scale(18.8083 4.75749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_85_559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8156 45.3432) rotate(-152.85) scale(25.8733 29.6627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_85_559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.6099 31.6265) rotate(-98.4711) scale(6.29585 7.20853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_85_559",
    width: 123,
    height: 126,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_85_559",
    width: 114,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABZCAYAAADitnCIAAAACXBIWXMAAAsSAAALEgHS3X78AAAED0lEQVR4Xu2c328UVRiGn1m6FrMVCVUsyo9EKEETufLOK/8C/25N1AsSbEQggFBawLRqge5i14tvTmZ2uj/awrJn3rzPzWm70+3kPHPO+c57Ni2GwyGm/XRmXWDagUWKYJEiWKQIFimCRYpgkSJYpAgWKYJFimCRIlikCBYpgkWKYJEiWKQIFimCRYpgkSJYpAgWKYJFimCRIlikCBYpgkWKYJEiWKQIFimCRYpgkSJYpAhLsy7ImKLRjmPYaGVpg8hxwgqgC3xQtuNkDoEB0C/bpkwpyTmLLIipfwlYZlRYFzgDnC/bJUZlDoE3wN/AdtkOGq83JbdabI4ik8Au0APOAWuMClsGPgOulu3ymPfZB7aAu2W7X/68KXmXkDlObGuk5iYyCVwBVoHLwDpwg0pYQdx3fUR2x7zXgNER+YZKTFPyHiF0G9gBXpfXtEZqkdF/9egAHxJyvgSuA98QIi8xKuxt18i65F1C5BbwB/AEeFZ+n6S+Jh6EAzIVmovIgpDyOfAt8B3wNXCFGJk9Dgt7m6q1KXlACN0CngOPgTtUUjeBv4B/y2sPyIycRH4E3AR+AL4nJK4QAjtMF3YS6pKT2H1i9O1QSf0T2AB+B+4To/gV8B8ZkcsamabKj4GLwIXy62Y1+i5pjugOMSusEH97jUrqV8BvwI/AL4TcrGTmIhKqIiZtNU4xP4njKJgsdZXRyhlC5ksymWZzEpm2BftUhcWiIsSm1C7xgKX+Svf5hFhnF74+5SIyrVG7RKGxTRQ4PeazPh6HgpgdesS03wdeAA/Ltj/5V98fuYiEeMIfAz8TIUCHWCvnWfAch/r26Atiyk2VtEdkSRqRz4Bfic75hygymluQRQqtR4bzLMSOTS4iIdbEV0QR0SfK/w2qUOAyh/eU9bVs3gyJKjVtU+pJ0cLJSSRER70kpthd4BGxMV9nNOU5C5xmNEw/SkBwEobEQzYgAoFN4mFLGW0WMnMTCdFpfWL/tkdVWCShN4ii4xMif01r1azIbproWQlQuo8HwG3gJ+JhS0H8wskl2ZlEweGTkAvAp0Scd42Q2SOETgrRU+AwTvRRMtk0M9wiEp57VAlPFvvI3EUmktAlYko9TUyv5wmBPSYfa6WgYdJpyVFOSTYIkWnLkV3m2haRiXqBUx9hKd6bdNA87fzyKOeWT4nQfI9KYFYd1zaRdepr3rSpEyZ/oqAua9onCeppU5Yd1maRTaYVMyddI9Pr9TZLlETO4iRVa2vIcfsxL1ovaxqLOl0w7xiLFMEiRbBIESxSBIsUwSJFsEgRLFIEixTBIkWwSBEsUgSLFMEiRbBIESxSBIsUwSJFsEgRLFIEixTBIkWwSBEsUgSLFMEiRbBIESxSBIsUwSJFsEgR/gdJ/ilV+TkiZwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_85_559",
    width: 99,
    height: 109,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.252144949d95460e82a1a3a8417e9830.svg";
export { ForwardRef as ReactComponent };